import * as actions from '../actions/systemParameters';

export const systemParameters = (state = {}, action) => {
    if (action.type === actions.SET_SYSTEM_PARAMETERS_DATA){
        // Change all keys to be upper case.
        return Object.entries(action.data).reduce((obj, [k, v]) => ({ ...obj, [k.toUpperCase()]: v }), {});
    }
    if (action.type === actions.UPDATE_SYSTEM_PARAMETER_DATA){
        // Update system parameters values to a given key.
        return {...state, [action.key]: action.data}
    }

    if (action.type === actions.CLEAR_SYSTEM_PARAMETERS_DATA) {
        return {};
    }

    return state;
}
